import { createContext, useContext, useState, useEffect } from "react";
import API from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        API.get("/auth/me")
            .then(res => setUser(res.data))
            .catch(() => setUser(null))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password, rememberMe = false) => {
        const res = await API.post("/auth/login", { email, password, remember_me: !!rememberMe });
        setUser(res.data);
        return res.data;
    };

    const register = async (name, email, password) => {
        const res = await API.post("/auth/register", { name, email, password });
        setUser(res.data);
        return res.data;
    };

    const logout = async () => {
        await API.post("/auth/logout");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
